import { useEffect, useState } from 'react';

import { canCreateProject } from './permissions';
interface UseCanCreateProjectLoading {
  loading: true;
  canCreateProject: undefined;
}

interface UseCanCreateProjectFulfilled {
  loading: false;
  canCreateProject: boolean;
}

export const useCanCreateProject = (
  jwmCloudId: string | undefined,
): UseCanCreateProjectLoading | UseCanCreateProjectFulfilled => {
  const [hasCreatePermission, setHasCreatePermission] = useState<
    boolean | undefined
  >(undefined);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const getLoadPermission = async (cloudId: string | undefined) => {
      const createPermission = cloudId
        ? await canCreateProject(cloudId)
        : false;
      setHasCreatePermission(createPermission);
      setIsLoading(false);
    };
    getLoadPermission(jwmCloudId);
  }, [jwmCloudId]);

  if (isLoading) {
    return { loading: true, canCreateProject: undefined };
  }
  return { loading: false, canCreateProject: hasCreatePermission as boolean };
};
